<dx-popup
  [visible]="isVisible"
  [showTitle]="false"
  [width]="'90%'"
  [maxWidth]="460"
  [height]="'auto'"
  (onHiding)="closeModal()"
>
  <div *dxTemplate="let data of 'content'" class="modal-wrapper">
    <!-- Header -->
    <div class="modal-header">
      <h4>Edit Holiday</h4>
      <button class="close-btn" (click)="closeModal()">&times;</button>
    </div>
    <!-- Modal Body -->
    <div class="modal-body">
      <!-- Single Date Field (Readonly) -->
      <div class="form-group">
        <label>Holiday Date</label>
        <div class="readonly-date-box">
          <input
            type="text"
            [value]="formattedDate"
            readonly
            class="form-control readonly-input"
          />
          <i class="dx-icon-event icon-right"></i>
        </div>
      </div>
      <div class="form-group">
        <label>Event Name</label>
        <dx-select-box
          [dataSource]="eventList"
          valueExpr="id"
          displayExpr="name"
          [(ngModel)]="selectedEventId"
          placeholder="Select event..."
        >
        </dx-select-box>
      </div>

      <!-- Cancel Switch Card -->
      <div class="toggle-card">
        <div>
          <strong class="toggle-title"
            >Cancel this Holiday & Mark as Working Day</strong
          >
          <p class="toggle-sub">
            Use this if the holiday was set up incorrectly. Requires a reason.
          </p>
        </div>
        <dx-switch [(value)]="cancelHoliday"></dx-switch>
      </div>

      <!-- Reason for change (Conditional) -->
      <div class="form-group" *ngIf="cancelHoliday">
        <label>Reason for change <span class="required">*</span></label>
        <input
          type="text"
          [(ngModel)]="reasonInput"
          placeholder="e.g., Holiday date was entered by mistake"
          class="form-control"
        />
      </div>
    </div>

    <!-- Footer Actions -->
    <div class="modal-footer">
      <dx-button
        type="default"
        text="Cancel"
        class="themeButtonWhite"
        (click)="closeModal()"
      ></dx-button>
      <dx-button
        text="Update Holiday"
        type="default"
        class="themeButton"
        (onClick)="onUpdate()"
      >
      </dx-button>
    </div>
  </div>
</dx-popup>
